import { Component } from '@angular/core';
import { Router } from '@angular/router';

interface HeroCopy {
    eyebrow: string;
    titleLine1: string;
    titleLine2: string;
    subtitle: string;
    cta: string;
    smallGroups: string;
    freeCancellation: string;
    reviewsLabel: string;
    rating4Of5InTripadvisor: string;
}

@Component({
    selector: 'app-hero-home',
    templateUrl: './hero-home.component.html',
    styleUrls: ['./hero-home.component.scss']
})
export class HeroHomeComponent {

    lang = 'en';

    /** Hero copy translations — SSR-friendly (no async loading) */
    private readonly heroCopy: Record<string, HeroCopy> = {
        en: {
            eyebrow: 'Top-rated local experiences',
            titleLine1: 'Buenos Aires',
            titleLine2: 'Tours & Day Trips',
            subtitle: 'Award-winning small-group & private experiences by local experts.',
            cta: 'Explore tours',
            smallGroups: 'Small groups',
            freeCancellation: 'Free cancellation',
            reviewsLabel: '(4,117+ reviews)',
            rating4Of5InTripadvisor: 'Rating 4.7 out of 5 on Tripadvisor',
        },
        es: {
            eyebrow: 'Experiencias locales de primera línea',
            titleLine1: 'Buenos Aires',
            titleLine2: 'Tours y excursiones',
            subtitle: 'Experiencias premiadas en grupos reducidos y privadas, con guías locales expertos.',
            cta: 'Ver tours',
            smallGroups: 'Grupos reducidos',
            freeCancellation: 'Cancelación gratis',
            reviewsLabel: '(4.117+ reseñas)',
            rating4Of5InTripadvisor: 'Calificación 4.7 de 5 en Tripadvisor',
        },
        pt: {
            eyebrow: 'Experiências locais premiadas',
            titleLine1: 'Buenos Aires',
            titleLine2: 'Passeios e excursões',
            subtitle: 'Experiências em pequenos grupos e privativas, com guias locais especialistas.',
            cta: 'Ver passeios',
            smallGroups: 'Grupos pequenos',
            freeCancellation: 'Cancelamento grátis',
            reviewsLabel: '(4.117+ avaliações)',
            rating4Of5InTripadvisor: 'Avaliação 4.7 de 5 no Tripadvisor',
        },
        'zh-cn': {
            eyebrow: '顶级本地体验',
            titleLine1: '布宜诺斯艾利斯',
            titleLine2: '旅游与一日游',
            subtitle: '获奖的小导游与私人定制体验，本地专家带领。',
            cta: '查看旅游',
            smallGroups: '小型团体',
            freeCancellation: '免费取消',
            reviewsLabel: '（4,117+条评论）',
            rating4Of5InTripadvisor: 'Tripadvisor评分 4.7 / 5',
        },
    };

    get copy(): HeroCopy {
        return this.heroCopy[this.lang] || this.heroCopy['en'];
    }

    constructor(private router: Router) {
        const parts = (this.router.url || '').split('/').filter(Boolean);
        const last = (parts[parts.length - 1] || 'en').toLowerCase();
        if (['en', 'es', 'pt', 'zh-cn'].includes(last)) {
            this.lang = last;
        }
    }

}
